import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import Graphic from "@arcgis/core/Graphic";
import { useStore } from "../../stores/store.ts";
let sketchViewModel: SketchViewModel;

export const togglePropertyInfo = ({ wasActive }) => {
  const { setTooltipText, mapView, bufferLayer, setSelectionGraphic } =
    useStore.getState();
  let hasUpdated = false;
  if (wasActive) {
    sketchViewModel?.destroy();
    setTooltipText("");
    return;
  }
  setTooltipText(wasActive ? "" : "Press down to start and let go to finish");
  if (!mapView || !bufferLayer) {
    return;
  }
  sketchViewModel = new SketchViewModel({
    view: mapView,
    layer: bufferLayer,
    polygonSymbol: {
      type: "simple-fill",
      color: "rgba(0, 0, 0, 0.4)",
      style: "solid",
      outline: {
        color: "red",
        width: 1,
      },
    },
    defaultUpdateOptions: {
      toggleToolOnClick: false,
    },
  });
  sketchViewModel.create("rectangle");
  sketchViewModel.on("create", (e) => {
    if (e.state === "active") {
      hasUpdated = true;
    }
    if (e.state === "complete") {
      if (!hasUpdated) {
        bufferLayer.removeAll();
        e.graphic = new Graphic({
          symbol: {
            type: "simple-marker",
            color: "rgba(0, 0, 0, 0.4)",
            outline: {
              color: "red",
              width: 1,
            },
          },
          geometry: {
            type: "point",
            x: e.graphic.geometry.centroid.x,
            y: e.graphic.geometry.centroid.y,
            spatialReference: mapView.spatialReference,
          },
        });
      }
      setSelectionGraphic(e.graphic);
      sketchViewModel.create("rectangle");
      setTooltipText("");
      hasUpdated = false;
    }
  });
};
